import { render } from "./ReviewCards.vue?vue&type=template&id=dd16b8a6&scoped=true&ts=true"
import script from "./ReviewCards.vue?vue&type=script&lang=ts"
export * from "./ReviewCards.vue?vue&type=script&lang=ts"

import "./ReviewCards.vue?vue&type=style&index=0&id=dd16b8a6&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd16b8a6"]])

export default __exports__